var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGalilio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #091f35;\n      }\n\n      .cls-4 {\n        fill: #00bbd6;\n      }\n\n      .cls-5, .cls-6, .cls-7 {\n        fill: none;\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-7 {\n        mask: url(#mask);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m11.7,9.45s0,0,0,.01c0,.02-.01.04-.02.06,0,.02-.02.04-.03.06,0,.02-.02.04-.03.06-.01.03-.03.06-.04.09-.16.35-.38.66-.63.94l1.02,1.07c.59-.62,1.03-1.39,1.27-2.23l-1.38-.32-.07-.02c-.03.09-.06.18-.1.27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 209.87,
    y1: 1372.21,
    x2: 209.9,
    y2: 1372.21,
    gradientTransform: "translate(-14061.53 92022.61) scale(67.05 -67.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 10,
    y: 8.32,
    width: 4.2,
    height: 4.27,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 10.46,
    y: 8.89,
    width: 3.28,
    height: 3.14,
    transform: "translate(-2.37 17.26) rotate(-65.99)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 209.87,
    y1: 1372.21,
    x2: 209.9,
    y2: 1372.21,
    gradientTransform: "translate(-14061.53 92022.61) scale(67.05 -67.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 16,
    height: 16,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Artwork_6",
    "data-name": "Artwork 6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m10.82,10.39s-.03.04-.04.05h0s-.01.03-.02.03h0s0,0,0,0c-.7.78-1.7,1.23-2.75,1.23-1.45,0-2.74-.83-3.34-2.13.28.09.57.16.87.18.84.06,1.65-.29,2.49-.29.7,0,1.36.23,1.99.52.28.13.55.27.82.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m13.25,9.51c-.14.49-.35.95-.61,1.38-.05.08-.1.15-.15.23-.15.22-.32.43-.51.63-1,1.06-2.41,1.72-3.98,1.72-2.43,0-4.48-1.58-5.19-3.77-.05-.17-.1-.34-.14-.51-.08-.38-.13-.78-.13-1.18,0-.05,0-.11,0-.16,0-.03,0-.07,0-.1,0-.04,0-.08,0-.12,0-.03,0-.06,0-.09,0-.02,0-.04,0-.06,0-.03,0-.06,0-.09,0-.03,0-.06.01-.09h0s.01-.09.02-.13c0,0,0,0,0,0,0-.06.02-.11.03-.17.01-.06.02-.12.04-.19.02-.07.03-.13.05-.2,0,0,0,0,0,0,.02-.06.04-.13.05-.19,0,0,0,0,0-.01.16-.5.38-.98.67-1.4.76-1.14,1.92-1.97,3.29-2.3l.14-.03.35-.08c.12-.02.23-.03.35-.04.14,0,.28-.02.42-.02.25,0,.5.02.75.05v1.51c-.24-.05-.49-.07-.75-.07-.15,0-.29,0-.44.02-1.88.21-3.37,1.73-3.52,3.63,0,.02,0,.05,0,.07,0,.05,0,.11,0,.16,0,.04,0,.07,0,.11,0,.49.09.97.25,1.4,0,.02.01.03.02.05.58,1.47,2.02,2.52,3.7,2.52,1.18,0,2.23-.51,2.96-1.33.01-.01.02-.03.03-.04.03-.04.06-.07.09-.11.2-.24.37-.51.5-.8.01-.03.03-.06.04-.09,0-.02.02-.04.03-.06,0-.02.02-.04.03-.06,0-.02.02-.04.02-.06,0,0,0,0,0-.01.04-.09.07-.18.1-.27l.07.02,1.38.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m13.46,8.02s0,.01,0,.02v.24s0,.01,0,.01c0,.04,0,.08,0,.13-.03.37-.09.74-.2,1.09l-1.38-.32-.07-.02h0s-3.05-.71-3.05-.71v-1.53l3.22.75,1.5.35Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.46,
    y: 8.89,
    width: 3.28,
    height: 3.14,
    transform: "translate(-2.37 17.26) rotate(-65.99)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m7.48,8.52c0,.32-.26.59-.59.59s-.59-.26-.59-.59.26-.59.59-.59.59.26.59.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m6.07,7.07c0,.21-.17.38-.38.38s-.38-.17-.38-.38.17-.38.38-.38.38.17.38.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m7.18,5.94c0,.16-.13.28-.28.28s-.28-.13-.28-.28.13-.28.28-.28.28.13.28.28"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalilio);
export default __webpack_public_path__ + "static/media/GALILIO.8a56938c31a675cea36e1ffdf24b266d.svg";
export { ForwardRef as ReactComponent };